/* -------------------------------------------------------------------------- */
/*                                Textarea styles                */
/* -------------------------------------------------------------------------- */

@import './bq-textarea.variables';

:host {
  @apply block is-full;
}

/* -------------------------------------------------------------------------- */
/*                                    Label                                   */
/* -------------------------------------------------------------------------- */

.bq-textarea__label {
  @apply text-[length:--bq-textarea--label-text-size] text-[color:--bq-textarea--label-text-color] m-be-[--bq-textarea--label-margin-bottom];
}

/* -------------------------------------------------------------------------- */
/*                        Native HTML Textarea control                        */
/* -------------------------------------------------------------------------- */

.bq-textarea__input {
  @apply flex-auto resize-y bg-[--bq-textarea--background-color] bs-[inherit];
  // Border
  @apply rounded-[--bq-textarea--border-radius] border-[length:--bq-textarea--border-width] border-[color:--bq-textarea--border-color];
  // Padding
  @apply pe-[--bq-textarea--padding-end] ps-[--bq-textarea--padding-start] p-b-[--bq-textarea--paddingY];
  // Text
  @apply text-[length:--bq-textarea--text-size] text-[color:--bq-textarea--text-color] placeholder:text-[color:--bq-textarea--text-placeholder-color];
  // Transition
  @apply transition-colors ease-in-out;
  // Hover
  @apply [&:not([disabled]):not(:focus-within)]:hover:border-hover-brand;
  // Disabled
  @apply disabled:cursor-not-allowed disabled:opacity-60;
  // Focus
  &:not([disabled]):focus-within {
    --bq-ring-width: 1px;
    --bq-ring-offset-width: 0;
    --bq-ring-color-focus: var(--bq-textarea--border-color-focus);

    @apply focus border-[color:--bq-ring-color-focus];
  }
}

/* ------------------------------- Validations ------------------------------- */

.bq-textarea__input.validation-error {
  @apply border-danger [&:not(.disabled):not(:focus-within)]:hover:border-hover-danger;

  &:not(.disabled):focus-within {
    --bq-ring-color-focus: theme(stroke.danger);

    @apply border-active-danger;
  }
}

.bq-textarea__input.validation-success {
  @apply border-success [&:not(.disabled):not(:focus-within)]:hover:border-hover-success;

  &:not(.disabled):focus-within {
    --bq-ring-color-focus: theme(stroke.success);

    @apply border-active-success;
  }
}

.bq-textarea__input.validation-warning {
  @apply border-warning [&:not(.disabled):not(:focus-within)]:hover:border-hover-warning;

  &:not(.disabled):focus-within {
    --bq-ring-color-focus: theme(stroke.warning);

    @apply border-active-warning;
  }
}

/* -------------------------------------------------------------------------- */
/*                                 Helper text                                */
/* -------------------------------------------------------------------------- */

.bq-textarea__helper {
  @apply text-[length:--bq-textarea--helper-text-size] text-[color:--bq-textarea--helper-text-color] m-bs-[--bq-textarea--helper-margin-top];
}

/* ------------------------------- Validations ------------------------------ */

.bq-textarea__helper.validation-error {
  @apply text-danger;
}

.bq-textarea__helper.validation-success {
  @apply text-success;
}

.bq-textarea__helper.validation-warning {
  @apply text-warning;
}

/* ----------------------------- Helper counter ----------------------------- */

/** Apply a disabled text color style to the textarea counter when the validation is none. */
.bq-textarea__helper[class~='validation-none'] {
  .bq-textarea__helper--counter {
    @apply opacity-60;
  }
}
